// extracted by mini-css-extract-plugin
module.exports = {"McsTitleBase":"McsTitleTertiary_McsTitleBase__3bmVa","McsTitleTitle":"McsTitleTertiary_McsTitleTitle__3RAVf"};